module.exports = __webpack_public_path__ + "static/img/3.1fa2fb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/3.png
// module id = cpr8
// module chunks = 0